import React from 'react';

import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Zoom from '@material-ui/core/Zoom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Collapse from '@material-ui/core/Collapse';
import Slide from '@material-ui/core/Slide';
import InputAdornment from '@material-ui/core/InputAdornment';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import { AdsAddBox ,BannerIklan} from '.';
import { read, write } from '../../utils/localStorageUtils';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogSearchIklan=React.memo((props)=>{
  const {
    open,
    onClose,
    onItemClick,
    onClickNew,
    //isMobile,
    adsList,
    searchText,
    onChangeSearchText,
  }=props

  const searchRef=React.useRef()
  const [tempSearchText,setTempSearchText]=React.useState("")
  const [editSearchMode,setEditSearchMode]=React.useState(true)
  const [historySearch,setHistorySearch]=React.useState([])

  const handleAdsClick=React.useCallback((ads)=>{
    if(!!onItemClick)onItemClick(ads)
  },[onItemClick])

  const handleShowEditSearchMode = React.useCallback(()=>{
    setEditSearchMode(true)
  },[])

  const handleHideEditSearchMode = React.useCallback(()=>{
    setEditSearchMode(false)
    if(!!onChangeSearchText)onChangeSearchText(tempSearchText)
  },[tempSearchText,onChangeSearchText])

  const handleChangeSearchText = React.useCallback((ev)=>{
    setTempSearchText(ev.target.value)
  },[])

  const handleKeyDown = React.useCallback((ev)=>{
    if (ev.key === "Enter") {
      ev.preventDefault();
      handleHideEditSearchMode()
    }
  },[handleHideEditSearchMode])
  
  const handleShowEditSearchModeClear = React.useCallback((ev)=>{
    if(!!onChangeSearchText)onChangeSearchText("")
    setTempSearchText("")
    handleShowEditSearchMode()
  },[handleShowEditSearchMode,onChangeSearchText])

  React.useEffect(()=>{
    if(open){
      handleShowEditSearchModeClear()
    }
  },[open,handleShowEditSearchModeClear])

  const handleClearTempSearch = React.useCallback(()=>{
    setTempSearchText("")
    searchRef.current.focus()
  },[])

  const handleBackButton=React.useCallback(()=>{
    if(editSearchMode&&!!tempSearchText){
      setEditSearchMode(false)
    }else{
      if(!!onClose) onClose()
    }
  },[editSearchMode,onClose,tempSearchText])
  
  const handleClickSuggestion = React.useCallback((str)=>{
    setTempSearchText(str)
    setEditSearchMode(false)
    if(!!onChangeSearchText)onChangeSearchText(str)
  },[onChangeSearchText])

  React.useEffect(()=>{
    if(!editSearchMode)return

    let stringSearch=read("cariiklan.search.history","",true)
    let history=stringSearch.split("|")
    if(!stringSearch){
      history=[]
    }
    setHistorySearch(history)
  },[editSearchMode])

  const handleClearHistorySearch = React.useCallback(()=>{
    write("cariiklan.search.history","",true)
    setHistorySearch([])
  },[])
  

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}  >
      <AppBar style={{position: 'sticky',top:0,transition:"background-color 0.5s"}} color={editSearchMode?"default":"primary"}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={handleBackButton}>
            <ArrowBackIcon />
          </IconButton>
          {editSearchMode?
            <TextField
              placeholder="Cari Iklan"
              style={{
                flexGrow:1,
              }}
              margin="normal"
              fullWidth
              autoFocus
              value={tempSearchText}
              onChange={handleChangeSearchText}
              onKeyDown={handleKeyDown}
              inputProps={{ref:searchRef}}
              InputProps={{
                endAdornment:!tempSearchText?null:(<InputAdornment>
                  <IconButton
                    onClick={handleClearTempSearch}
                    size="small"
                  >
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>)
              }}
            />
          :
            <Typography
              variant="h5"
              style={{
                flexGrow:1,
                padding:"0px 8px",
                cursor:"pointer",
              }}
              onClick={handleShowEditSearchMode}
              tabIndex="0"
              onKeyDown={handleShowEditSearchMode}
            >
              {searchText||"Cari Iklan"}
            </Typography>
          }          
        </Toolbar>
      </AppBar>

      
      <Collapse
        in={editSearchMode&&!!tempSearchText}
        timeout={500}
      >
        <Box
          style={{
            padding:"8px",
          }}
        >
          {historySearch.length>0&&<Typography
            variant="h6"
            style={{
              margin:"16px 0px"
            }}
          >
            Terakhir dicari
            <IconButton
              style={{
                float:"right",
              }}
              onClick={handleClearHistorySearch}
            >
              <DeleteForeverIcon/>
            </IconButton>
          </Typography>}


          <Box
            style={{
              display:"flex",
              flexWrap: "wrap",
            }}
          >
            {historySearch.map((str,i)=>(
              <SuggestionWord
                key={i}
                word={str}
                onClick={handleClickSuggestion}
              />
            ))}
          </Box>
          

          {historySearch.length>0&&<Divider
            style={{
              marginTop:"32px"
            }}
          />}

          <Typography
            variant="h6"
            style={{
              margin:"16px 0px"
            }}
          >
            Pencarian Populer
          </Typography>

          <Box
            style={{
              display:"flex",
              flexWrap: "wrap",
            }}
          >
            {["hampers","tape","acrylic"].map((str,i)=>(
              <SuggestionWord
                key={i}
                word={str}
                onClick={handleClickSuggestion}
              />
            ))}
          </Box>

          <Divider
            style={{
              marginTop:"32px"
            }}
          />

        </Box>
      </Collapse>

      <Collapse
        in={!(editSearchMode&&!!tempSearchText)}
        timeout={500}
      >
        <Box
          style={{
            padding:"8px",
          }}
        >
          {(adsList.length===0&&!!searchText)&&(
            <Typography
              style={{
                textAlign:"center",
                margin:"48px",
              }}
              variant="h6"
            >
              Pencarian "{searchText}" tidak ditemukan
            </Typography>
          )}
          
          <Grid
            container
            direction="row"
            //justifyContent="space-between"
            alignItems="flex-start"
            style={{
              justifyContent:"space-between",
              scrollBehavior: "smooth",
            }}
          >
            {!searchText&&<AdsAddBox onClick={onClickNew} light={false} fullWidth={true}/>}
            
            {adsList.map((ads,i)=>(
              <Grid 
                item
                key={i}
                xs={12}
                sm={6}
              >
                <BannerIklan
                  ads={ads}
                  onClick={handleAdsClick}
                />
              </Grid>
            ))}
          </Grid>
          
        </Box>
      </Collapse>
      

      <Zoom
        in={open&&!editSearchMode}
        timeout={500}
      >
        <Fab
          style={{
            position: 'fixed',
            bottom: "16px",
            right: "16px",
          }}
          color="primary"
          onClick={handleShowEditSearchModeClear}
        >
          <SearchIcon />
        </Fab>
      </Zoom>
      
    </Dialog>
  )
})

const SuggestionWord=React.memo((props)=>{
  const {
    word,
    onClick,
  }=props

  const handleClick=React.useCallback(()=>{
    if(!!onClick) onClick(word)
  },[onClick,word])

  return (
    <span  
      style={{
        margin:"8px",
        border:"1px solid black",
        borderRadius:"2px",
        padding:"8px",
        fontWeight:"bold",
        whiteSpace:"nowrap",
      }}
      tabIndex="0"
      onKeyDown={handleClick}
      onClick={handleClick}
    >
      {word}
    </span>
  )
})

export default DialogSearchIklan